export const LOGIN_CALLBACK_END_POINT = {
  EXCHANGE_GOOGLE_CODE: 'oauth/google/callback',
};
